import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Alert,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { AddLevel2 } from "../../redux/actions/AddLevel2Action";

const AddLevel2Modal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.addLevel2.status);
  const [form, setForm] = useState({
    name: "",
    isActive: true,
    idLevel1: "",
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const loading = status === "loading";

  useEffect(() => {
    if (open) {
      setForm({
        name: "",
        isActive: true,
      });
      setMessage({ type: "", text: "" });
    }
  }, [open]);

  const isFormValid = () =>
    form.name.trim() !== "" && form.idLevel1 !== "";

  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    setMessage({ type: "", text: "" });

    try {
      const result = await dispatch(AddLevel2(form));

      if (result.success) {
        setMessage({ type: "success", text: result.message });
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        setMessage({ type: "error", text: result.message });
      }
    } catch {
      setMessage({
        type: "error",
        text: "There was an error creating the menu level 2. Please try again.",
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Menu Level 2</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            fullWidth
            required
            disabled={loading}
          />
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={(e) =>
                  setForm({ ...form, isActive: e.target.checked })
                }
                disabled={loading}
              />
            }
            label="Active"
          />

          {message.text && (
            <Alert
              severity={message.type}
              onClose={() => setMessage({ type: "", text: "" })}
            >
              {message.text}
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!isFormValid() || loading}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
          sx={{
            backgroundColor: "#4b4bfa",
            "&:hover": { backgroundColor: "#3e3ed9" },
            color: "#fff",
          }}
        >
          {loading ? "Saving..." : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddLevel2Modal;
